__turbopack_context__.v({
  "backChevron": "fTpKNW_backChevron",
  "backLink": "fTpKNW_backLink",
  "backText": "fTpKNW_backText",
  "checkbox": "fTpKNW_checkbox",
  "checkboxLabel": "fTpKNW_checkboxLabel",
  "checkboxRow": "fTpKNW_checkboxRow",
  "errorText": "fTpKNW_errorText",
  "field": "fTpKNW_field",
  "form": "fTpKNW_form",
  "formInner": "fTpKNW_formInner",
  "input": "fTpKNW_input",
  "inputError": "fTpKNW_inputError",
  "label": "fTpKNW_label",
  "namesRow": "fTpKNW_namesRow",
  "page": "fTpKNW_page",
  "passwordBlock": "fTpKNW_passwordBlock",
  "profileHeading": "fTpKNW_profileHeading",
  "profileTitle": "fTpKNW_profileTitle",
  "requiredMark": "fTpKNW_requiredMark",
  "submitWrap": "fTpKNW_submitWrap",
});
